import React from "react";
import { Shape, ExtrudeGeometry, EdgesGeometry, LineBasicMaterial } from "three";

const RectangularTube = ({ b = 5, h = 3, e = 0.5, height = 10, material }) =>
{
  const shape = new Shape();

  // 🔹 Dibuja el rectángulo exterior
  shape.moveTo(-b / 2, -h / 2);
  shape.lineTo(b / 2, -h / 2);
  shape.lineTo(b / 2, h / 2);
  shape.lineTo(-b / 2, h / 2);
  shape.lineTo(-b / 2, -h / 2); // Cierra el contorno exterior

  // 🔹 Define el contorno interior (rectángulo hueco dentro del tubo)
  const hole = new Shape();
  hole.moveTo(-b / 2 + e, -h / 2 + e);
  hole.lineTo(b / 2 - e, -h / 2 + e);
  hole.lineTo(b / 2 - e, h / 2 - e);
  hole.lineTo(-b / 2 + e, h / 2 - e);
  hole.lineTo(-b / 2 + e, -h / 2 + e); // Cierra el hueco

  shape.holes.push(hole); // Agregar el hueco al shape

  // 🔹 Extruir el shape para hacer el tubo 3D
  const extrudeSettings = { depth: height, bevelEnabled: false };
  const geometry = new ExtrudeGeometry(shape, extrudeSettings);

  // 🔹 Centrar la extrusión para que coincida con BoxGeometry
  geometry.translate(0, 0, -height / 2);
  geometry.rotateX(Math.PI / 2);

  // 🔹 Crear líneas de borde
  const edges = new EdgesGeometry(geometry);
  const lineMaterial = new LineBasicMaterial({ color: 0x000000 }); // Bordes negros

  return (
    <>
      <mesh
        name={`RectangularTube_${b}_${h}_${height}`} // ← Renombrado, no comienza con "mesh"
        geometry={geometry}
        material={material}
      />
      <lineSegments
        name={`RectangularTube_Edges_${b}_${h}_${height}`} // ← Nombre para las líneas
        geometry={edges}
        material={lineMaterial}
      />
    </>
  );
};

export default RectangularTube;